var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5187 20.7858H7.8151V18.7858H14.5187V20.7858Z",
    fill: "#6F757C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1983 21.0496C25.0165 21.0496 25.6798 20.3863 25.6798 19.5681C25.6798 18.7499 25.0165 18.0866 24.1983 18.0866C23.3801 18.0866 22.7168 18.7499 22.7168 19.5681C22.7168 20.3863 23.3801 21.0496 24.1983 21.0496Z",
    fill: "#6F757C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16666 9.33335C3.16666 7.86059 4.36057 6.66669 5.83333 6.66669H27.1667C28.6394 6.66669 29.8333 7.86059 29.8333 9.33335V22.6667C29.8333 24.1394 28.6394 25.3334 27.1667 25.3334H5.83333C4.36057 25.3334 3.16666 24.1394 3.16666 22.6667V9.33335ZM5.83333 9.33335H27.1667V12.2116L5.83333 12.2116V9.33335ZM5.83333 14.8783V22.6667H27.1667V14.8783L5.83333 14.8783Z",
    fill: "#6F757C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.f5f6b8581cf7686aecbc4f50944ba7af.svg";
export { ForwardRef as ReactComponent };